import { isDirtyTransaction } from '@atlaskit/editor-common/collab';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { isOrganicChange } from '../utils';
export var trackLastOrganicChangePluginKey = new PluginKey('collabTrackLastOrganicChangePlugin');
export var createPlugin = function createPlugin() {
  return new SafePlugin({
    key: trackLastOrganicChangePluginKey,
    state: {
      init: function init() {
        return {
          lastLocalOrganicChangeAt: null,
          lastRemoteOrganicChangeAt: null
        };
      },
      apply: function apply(transaction, prevPluginState) {
        if (Boolean(transaction.getMeta('appendedTransaction'))) {
          return prevPluginState;
        }
        var isRemote = Boolean(transaction.getMeta('isRemote'));
        var isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
        if (isDocumentReplaceFromRemote) {
          return prevPluginState;
        }
        if (isDirtyTransaction(transaction)) {
          return prevPluginState;
        }
        if (isOrganicChange(transaction)) {
          if (isRemote) {
            return {
              lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
              lastRemoteOrganicChangeAt: Date.now()
            };
          }
          return {
            lastLocalOrganicChangeAt: Date.now(),
            lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt
          };
        }
        return prevPluginState;
      }
    }
  });
};